import { render } from "./BuildingKit.vue?vue&type=template&id=3872531f&scoped=true&lang=pug"
import script from "./BuildingKit.js?vue&type=script&lang=js&external"
export * from "./BuildingKit.js?vue&type=script&lang=js&external"

import "./BuildingKit.vue?vue&type=style&index=0&id=3872531f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3872531f"]])

export default __exports__